import React from "react";
import { GLUtils } from "@capture/gl-core";
import { ShapeGLPipeline, ShapeWorker } from '@capture/shape-core';
import ThumbsUpDown from "../components/ThumbsUpDown"
import DownloadTopPanel from "../components/DownloadTopPanel"
import Button from '@react/react-spectrum/Button';
import Switch from '@react/react-spectrum/Switch';
import Header from "../components/headers/Header";
let _shapeWorker;

export default class ShapeCanvas extends React.Component {
    state = {
        isLoading: false,
        image: null,
        stopsCount: 50
    };
    constructor(props) {
        super(props);
        _shapeWorker = new ShapeWorker();
        this.canvas = React.createRef();
        this.gl = null;
        this.frameID = null;
        this.texture = null;
        this._draw = this._draw.bind(this);
        this._loadTexture = this._loadTexture.bind(this);
        this._updateDimensions = this._updateDimensions.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleInvert = this.handleInvert.bind(this);
    }

    componentDidMount() {
        this.setState({ image: this.props.image.image })
    }
    componentDidUpdate(prevprops, prevState) {
        if (this.state.image !== prevState.image) {
            this._loadTexture(this.state.image);
        }
    }
    _draw() {
        if (this.gl) {
            const canvas = this.refs.canvas
            const pipeline = ShapeGLPipeline;
            pipeline.bind(this.gl);
            pipeline.setViewSize(this.gl, canvas.width, canvas.height);
            pipeline.setSize(this.gl, this.textureWidth, this.textureHeight);
            pipeline.draw(this.gl, this.texture);
            this.frameID = requestAnimationFrame(this._draw);
        }
    }
    _loadTexture(imageURI) {
        if (this.frameID) {
            cancelAnimationFrame(this.frameID);
        }
        // window.addEventListener('resize', this._updateDimensions);
        const canvas = this.refs.canvas;
        // need to add preserveDrawingBuffer so canvas doesn't return blank
        this.gl = canvas.getContext('webgl', { preserveDrawingBuffer: true });
        this.texture = GLUtils.loadTexture(this.gl, imageURI, (_, textureWidth, textureHeight) => {
            this.textureWidth = textureWidth;
            this.textureHeight = textureHeight;
            this._updateDimensions();
            this.frameID = requestAnimationFrame(this._draw);
        });
    }
    handleChange(event) {
        const detail = event.target.value;
        ShapeGLPipeline.setDetail(detail);
        this.setState({
            stopsCount: detail
        })
    }
    _updateDimensions() {
        const canvas = this.refs.canvas
        if (canvas) {
            var displayWidth = canvas.clientWidth;
            var displayHeight = canvas.clientHeight;
            if (canvas.width !== displayWidth || canvas.height !== displayHeight) {
                canvas.width = displayWidth;
                canvas.height = displayHeight;
            }
        }
    }
    handleInvert() {
        const isInverted = !ShapeGLPipeline.isInverted();
        ShapeGLPipeline.setInverted(isInverted);
    }
    downloadPNG = () => {
        var canvas = this.refs.canvas
        var url = canvas.toDataURL("image/png");
        var link = document.createElement('a');
        link.download = 'capture-shapes.png';
        link.href = canvas.toDataURL();
        link.click();
        this.setState({
            link: link.href
        })
    }
    // download as SVG
    handleSave = () => {
        this.setState({
            isLoading: true
        });
        this._convertToSvg().then(data => {
            this.setState({
                isLoading: false
            });
            this._download('capture-shape.svg', data.svg);
        })
    }
    _convertToSvg = () => {
        return new Promise(resolve => {
            ShapeGLPipeline.process(this.props.image.image).then(dataURI => {

                const image = new Image();
                image.onload = function () {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0);
                    const imageData = ctx.getImageData(0, 0, image.width, image.height).data;
                    let message = {
                        imageData,
                        width: image.width,
                        height: image.height,
                        isSmoothingEnabled: true
                    };
                    _shapeWorker.onmessage = result => {
                        resolve({
                            svg: result.data.svg
                        })
                    };
                    _shapeWorker.postMessage(message);
                };
                image.src = dataURI;
            });
        })
    }

    _download = (filename, content) => {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(content));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    handleUpload = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0];
            let src = URL.createObjectURL(img);
            this.setState({
                image: src,
                loaded: true
            });
        }
    }
    render() {
        const { isLoading } = this.state
        return (
            <>
            <div className="patternTheme">
                <div className="downloadedPanel">
                    <div className="firstDownloadPanel">
                        <DownloadTopPanel title={this.props.image.title} desc={this.props.image.desc} />
                   
                        <div className="downloadButtons">
                            <Button variant="cta" onClick={this.downloadPNG}> Download</Button>
                            <input type="file" name="imgUpload" ref="file" className="inputfile" onChange={this.handleUpload}
                                accept=".png,.jpg"
                            />
                            <Button onClick={() => this.refs.file.click()}>Add new</Button>
                    </div>
                    </div>
                    <ThumbsUpDown title ={this.props.image.title}/>
                </div>
                <div className="patternCanvas">
                    <canvas className="canvasPattern" ref="canvas" />
                    <div className="scaleRotate">
                        <div>
                        <div>
                            <p style={{ float: "left" }}>Detail</p><p style={{ float: "right" }}>{this.state.stopsCount}</p>
                        </div>
                        <div>
                            <input type="range" min="1" max="100" onChange={this.handleChange} value={this.state.stopsCount} />
                        </div>
                        </div>
                        <div className="alignItems">
                            <Switch onChange={() => { this.handleInvert() }}></Switch> Invert
                    </div>
                        <div>
                            <Button onClick={this.handleSave}>
                                {isLoading ? "Converting to SVG..." : "Download to SVG"}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}
